import { FirebaseData } from "../General/FirebaseData";
import { UnlocLock } from "../Property/Integrations/Unloc/UnlocTypes";
import { LocksLoader } from "@pages/Property/Locks/LocksLoader";

export class LockHolderAccessGroupData extends FirebaseData {
  name: string = "";
  locks: UnlocLock[] = [];
  members: {
    phone?: string;
  }[] = [];

  setup(data: any) {
    this.name = typeof data.name === "string" ? data.name : "";
    this.members = Array.isArray(data.members) ? data.members : [];

    this.locks = [];
    if (Array.isArray(data.locks)) {
      for (const lockID of data.locks) {
        const lock = LocksLoader.getLockWithId(lockID);
        if (lock) this.locks.push(lock);
      }
    }
  }
}

